/* eslint-disable max-len */
import * as questionIds from "../../consultationQuestions/questionIds";

export const havsQuestions = [
    {
        id: questionIds.HavsAssessmentRequired,
        questionText: "Following review of the HAVS questionnaire",
    },
    {
        id: questionIds.EverSufferedBlanching,
        questionText: "Have you ever suffered from your fingers going white?",
    },
    {
        id: questionIds.BlanchingInResponseToColdDampOrWet,
        questionText: "In response to cold, damp or wet conditions?",
    },
    {
        id: questionIds.BlanchingWhileWorking,
        questionText: "While working?",
    },
    {
        id: questionIds.BlanchingOtherTimes,
        questionText: "At other times?",
    },
    {
        id: questionIds.BlanchingOtherTimesExamples,
        questionText: "Please give examples:",
    },
    {
        id: questionIds.BlanchingFirstNoticed,
        questionText: "When did you first notice this whiteness? (Year)",
    },
    {
        id: questionIds.BlanchingHowOften,
        questionText: "How often does it occur?",
    },
    {
        id: questionIds.BlanchingMostCommonCircumstances,
        questionText: "State most common circumstances",
    },
    {
        id: questionIds.ExperienceWhitenessInFeetOrOtherPeriphery,
        questionText: "Do you experience whiteness in your feet or other periphery?",
    },
    {
        id: questionIds.ExperienceWhitenessInFeetOrOtherPeripheryWhere,
        questionText: "Please state where whiteness is experienced",
    },
    {
        id: questionIds.WhichFingersAffectedByBlanching,
        questionText: "Which fingers are affected? (Click all fingers that have ever gone white)",
    },
    {
        id: questionIds.BlanchingWitnessed,
        questionText: "Is the blanching witnessed",
    },
    {
        id: questionIds.BlanchingNotWitnessed,
        questionText: "Is the blanching not witnessed",
    },
    {
        id: questionIds.Tingling,
        questionText: "Tingling (excluding transient tingling lasting for up to 20 minutes after using vibrating tools)",
    },
    {
        id: questionIds.ExperienceTinglingOfFingers,
        questionText: "Do you experience tingling of the fingers?",
    },
    {
        id: questionIds.TinglingResponseToCold,
        questionText: "In response to the cold?",
    },
    {
        id: questionIds.TinglingWithBlanching,
        questionText: "With blanching?",
    },
    {
        id: questionIds.TinglingWhileWorking,
        questionText: "While working?",
    },
    {
        id: questionIds.TinglingAtOtherTimes,
        questionText: "At other times?",
    },
    {
        id: questionIds.TinglingAtOtherTimesExamples,
        questionText: "Please give examples and how long it lasts:",
    },
    {
        id: questionIds.TinglingWhenFirstNoticed,
        questionText: "When did you first notice this? (Year)",
    },
    {
        id: questionIds.TinglingWhichFingersAffected,
        questionText: "Which fingers are affected? (Click all fingers that have ever gone white)",
    },
    {
        id: questionIds.Numbness,
        questionText: "Numbness (excluding transient tingling lasting for up to 20 minutes after using vibrating tools)",
    },
    {
        id: questionIds.DoFingersGoNumb,
        questionText: "Do your fingers go numb?",
    },
    {
        id: questionIds.NumbnessResponseToCold,
        questionText: "In response to the cold?",
    },
    {
        id: questionIds.NumbnessWithBlanching,
        questionText: "With blanching?",
    },
    {
        id: questionIds.NumbnessWhileWorking,
        questionText: "While working?",
    },
    {
        id: questionIds.NumbnessOtherTimes,
        questionText: "At other times?",
    },
    {
        id: questionIds.NumbnessOtherTimesExamples,
        questionText: "Please give examples and how long it lasts:",
    },
    {
        id: questionIds.NumbnessFirstNotice,
        questionText: "When did you first notice this? (Year)",
    },
    {
        id: questionIds.NumbnessWhichFingers,
        questionText: "Which fingers are affected? (Click all fingers that have ever gone numb)",
    },
    {
        id: questionIds.NumbnessDifficultyHandlingSmallObjects,
        questionText: "Do you have any difficulty handling or manipulating small objects?",
    },
    {
        id: questionIds.NumbnessDifficultyHandlingSmallObjectsWhen,
        questionText: "When does this occur",
    },
    {
        id: questionIds.AnyBlanchingTinglingNumbnessAffectWorkOrLeisure,
        questionText: "Do any of these symptoms (blanching, tingling or numbness) affect your work or leisure activities?",
    },
    {
        id: questionIds.AnyBlanchingTinglingNumbnessAffectWorkOrLeisureFurtherDetails,
        questionText: "Please give details",
    },
    {
        id: questionIds.ProblemsWithMusclesOrJoints,
        questionText: "Are you experiencing problems with the muscles or joints of your hands/arms/wrists/elbows/shoulders?",
    },
    {
        id: questionIds.ProblemsWithMusclesOrJointsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Pain,
        questionText: "Pain",
    },
    {
        id: questionIds.PainFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Stiffness,
        questionText: "Stiffness",
    },
    {
        id: questionIds.StiffnessFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Swelling,
        questionText: "Swelling",
    },
    {
        id: questionIds.SwellingFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Weakness,
        questionText: "Weakness",
    },
    {
        id: questionIds.WeaknessFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.DominantHand,
        questionText: "Dominant hand",
    },
    {
        id: questionIds.LeadingHand,
        questionText: "Leading hand",
    },
    {
        id: questionIds.FirstStartUsingVibrating,
        questionText: "When did you first start using vibrating tools or equipment?",
    },
    {
        id: questionIds.WhereNoticeVibrationMost,
        questionText: "Where do you notice the vibration most?",
    },
    {
        id: questionIds.WhenStopUsingVibratingTools,
        questionText: "If you no longer use vibrating tools when did you stop?",
    },
    {
        id: questionIds.MainElementsJobInvolvingVibratingTools,
        questionText: "Which of the main elements of your present job involve use of vibrating tools or equipment and how much time per day (‘trigger’ or contact time)? Include the Hours/Day and Days/Week in the description",
    },
    {
        id: questionIds.WhenJoinCompany,
        questionText: "When did you join the company?",
    },
    {
        id: questionIds.MainJobsAndDepartments,
        questionText: "List main jobs and departments in order (include the Hours/Day and Days/Week):",
    },
    {
        id: questionIds.PreviousJobsInvolvingVibrations,
        questionText: "What jobs did you do previously, outside this company, involving vibration? Include the Hours/Day and Days/Week in the description",
    },
    {
        id: questionIds.ExposureToChemicalsAtWork,
        questionText: "Have you had any exposure to chemicals at work?",
    },
    {
        id: questionIds.ExposureToChemicalsAtWorkFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.HandArmVibrationHobbies,
        questionText: "Do any of your hobbies expose you to hand-arm vibration?",
    },
    {
        id: questionIds.HandArmVibrationHobbiesFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.DoYouSmoke,
        questionText: "Do you smoke?",
    },
    {
        id: questionIds.HowManySmokePerDay,
        questionText: "How many do you smoke each day?",
    },
    {
        id: questionIds.ExSmoker,
        questionText: "Are you an ex-smoker?",
    },
    {
        id: questionIds.ExSmokerWhenQuit,
        questionText: "Please state when you quit",
    },
    {
        id: questionIds.DrinkAlcohol,
        questionText: "Do you drink alcohol?",
    },
    {
        id: questionIds.DrinkAlcoholNumberOfUnitsPerWeek,
        questionText: "Please state approx. units consumed per week",
    },
    {
        id: questionIds.CloseFamilyVibrationWhiteFinger,
        questionText: "Do other members of your family suffer from white finger? (brothers, sisters and parents only)",
    },
    {
        id: questionIds.CloseFamilyVibrationWhiteFingerWho,
        questionText: "Who?",
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperation,
        questionText: "Have you ever had a neck/arm/hand injury?",
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationWhatWhen,
        questionText: "What and when?",
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationAnyProblems,
        questionText: "Were you left with any problems?",
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationAnyProblemsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SeriousDiseaseJoints,
        questionText: "Joints?",
    },
    {
        id: questionIds.SeriousDiseaseJointsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SeriousDiseaseSkin,
        questionText: "Skin?",
    },
    {
        id: questionIds.SeriousDiseaseSkinFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SeriousDiseaseNerves,
        questionText: "Nerves?",
    },
    {
        id: questionIds.SeriousDiseaseNervesFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SeriousDiseaseHeartBloodVessels,
        questionText: "Heart or Blood vessels?",
    },
    {
        id: questionIds.SeriousDiseaseHeartBloodVesselsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SeriousDiseaseOther,
        questionText: "Other?",
    },
    {
        id: questionIds.SeriousDiseaseOtherFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.AnyLongTermMedicationTreatmentForCondition,
        questionText: "Are you on any long-term medication or treatment for any condition:",
    },
    {
        id: questionIds.AnyLongTermMedicationTreatmentForConditionFurtherDetails,
        questionText: "Please provide details",
    },

    {
        id: questionIds.HavsTier,
        questionText: "What tier are you undertaking?",
    },
    {
        id: questionIds.ClinicalAssessmentOfHavsSignsAndSymptomReview,
        questionText: "Clinical Assessment: Please indicate if a 3-yearly assessment for a HAVS signs and symptom review with a qualified person has been undertaken",
    },
    {
        id: questionIds.TierOneOutcome,
        questionText: "Outcome",
    },
    {
        id: questionIds.AdditionalAdviceAndRecallPlan,
        questionText: "Additional Advice and Recall Plan",
    },
    {
        id: questionIds.TierTwoOutcome,
        questionText: "Outcome",
    },
    {
        id: questionIds.BlanchingWitnessedByPersonCompletingScreening,
        questionText: "Is the blanching witnessed by the person completing the screening?",
    },
    {
        id: questionIds.PreviousJobsInvolvingVibrationsUpdated,
        questionText: "What jobs did you do previously, outside this company, involving vibration? Include the Hours/Day and Days/Week/Years in the description",
    },
    {
        id: questionIds.EverNeckArmHandInjuryOrOperationUpdated,
        questionText: "Have you ever had a neck/arm/hand injury or operation?",
    },
    {
        id: questionIds.AdditionalClinicalNotes,
        questionText: "Additional Clinical Notes",
    },
    {
        id: questionIds.TinglingWhichFingersAffectedUpdated,
        questionText: "Which fingers are affected? (Click all fingers that have ever had tingling)",
    }
];
/* eslint-enable max-len */
